/******************************************************
 *                 Courses Spéciales détails
 ********************************************************/
"use strict";

import dayjs from "dayjs";

angular.module("exploitation")

	.controller("CoursesSpecialesCtrlDetails", ["$scope", "Utils", "$uibModal", "editable", "EitiCompaniesService", "CoursesSpecialesService", "toastr", "course", "$controller", "$location",
		function ($scope, Utils, $uibModal, editable, EitiCompaniesService, CoursesSpecialesService, toastr, course, $controller, $location) {

		$controller("CoursesSpecialesCtrlParent", {$scope: $scope});

		$scope.data = course.data;

		$scope.data.serviceDate = new Date(course.data.serviceDatetime);
		$scope.data.serviceTime = new Date(course.data.serviceDatetime);

		$scope.data.departure = $scope.data.stops[0];
		$scope.data.departure.dateDeparture = $scope.data.departure.timeDeparture = new Date($scope.data.departure.datetimeDeparture);
		$scope.data.departure.dateArrival = $scope.data.departure.timeArrival = new Date($scope.data.departure.datetimeArrival);

		$scope.data.arrival = $scope.data.stops[$scope.data.stops.length - 1];
		$scope.data.arrival.dateDeparture = $scope.data.arrival.timeDeparture = new Date($scope.data.arrival.datetimeDeparture);
		$scope.data.arrival.dateArrival = $scope.data.arrival.timeArrival = new Date($scope.data.arrival.datetimeArrival);

		$scope.data.stops.splice(0, 1);
		$scope.data.stops.splice($scope.data.stops.length - 1, 1);

		//Initialisation de la company
		$scope.data.company = $scope.data.okinaCompany.id;

		/**
         * Récupérer toutes les companies
         */
		EitiCompaniesService.getAll(true).then((response) => {
			$scope.companies = response.data;
		});


		function createCalendarParams() {
			$scope.calendar = [];

			for (var i = 0; i <= 2; i++) {
				$scope.calendar[i] = {
					opened: {
						start: false,
						end: false,
						service: false
					},
					open: function ($event, which, numCalendarParam) {
						$event.preventDefault();
						$event.stopPropagation();
						$scope.calendar[numCalendarParam].opened[which] = true;
					}
				};
			}
		}

		//Vérifier que le formulaire est éditable
		function checkEditable() {
			if (new Date($scope.data.serviceDate) < new Date()) {
				$scope.editable = false;
			} else {
				$scope.editable = editable;
			}
		}

		checkEditable();


		/**
         * Créer une nouvelle course spéciale
         * @param data
         */
		$scope.putCourseSpeciale = function (data) {
			$scope.data.serviceDatetime = getIsoDateTime($scope.data.serviceDate, $scope.data.serviceTime);
			$scope.data.departure.datetimeDeparture = getIsoDateTime($scope.data.departure.dateDeparture, $scope.data.departure.timeDeparture);
			$scope.data.arrival.datetimeArrival = getIsoDateTime($scope.data.arrival.dateArrival, $scope.data.arrival.timeArrival);
			$scope.data.companyId = $scope.data.company;
			$scope.data.arrival.datetimeDeparture = $scope.data.arrival.datetimeArrival;
			$scope.data.departure.datetimeArrival = $scope.data.departure.datetimeDeparture;

			$scope.data.stops.push($scope.data.arrival);
			$scope.data.stops.push($scope.data.departure);

			CoursesSpecialesService.putCourseSpeciale(data)
				.then(() => {
					toastr.success("", "La course spéciale a bien été mise à jour.");
					$location.path("/e-iti/course-speciale");
				})
				.catch((error) => {
					const data = error.data;
					let errorMessage = "Problème lors de la mise à jour de la course spéciale.";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");

					// Enlever le point de départ et d'arriver des étapes
					$scope.data.stops.pop(); //Depart
					$scope.data.stops.pop(); //Arrivé
				});
		};


		/**
         * Inverser le sens du parcours
         */
		$scope.inverse = function (data) {
			inverseContentData("city");
			inverseContentData("zipCode");
			inverseContentData("address");
			inverseContentData("description");
			inverseContentData("libelle");
			toastr.info("Pensez à modifier les étapes de votre parcours", "Sens modifié");
		};

		/**
         * Inverser deux variables
         */
		function inverseContentData(element) {
			var obj = $scope.data.departure[element];
			$scope.data.departure[element] = $scope.data.arrival[element];
			$scope.data.arrival[element] = obj;
		}

		/**
         * Dupliquer la course
         */
		$scope.duplicate = function (data) {
			CoursesSpecialesService.duplicateCourseSpeciale(data.id)
				.then((response) => {
					toastr.success("", "Course dupliquée.");
					$location.path("/e-iti/course-speciale/" + response.data.id + "/edit");
					toastr.info("", "Faites à présent d'éventuelles modifications sur cette nouvelle course");
				})
				.catch((error) => {
					const data = error.data;
					let errorMessage = "Problème lors de la procédure pour dupliquer la course.";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
		};


		/**
         * Avoir un format de date correct
         * @param date
         * @returns {string}
         */
		function getIsoDateTime(date, time) {
			return dayjs(date)
				.hour(time.getHours())
				.minute(time.getMinutes())
				.second(0)
				.millisecond(0)
				.toISOString();
		}

		createCalendarParams();

	}]);
